<div class="box">
  <div class="box-row header">
    <app-header-bar [date]="date" [title]="'dashboard.title'"></app-header-bar>
  </div>
  <app-loading-indicator [loading]="isLoading"></app-loading-indicator>
  <div class="content mb-3">
    <div class="row mt-4">
      <ng-template #dashboardContainer></ng-template>
    </div>
  </div>
</div>
